import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchPrograms, IProgram, ProgramActionKeys, programsActionCreators } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';

function* fetchProgramsSaga(action: FetchPrograms) {
  yield put(uiActionCreators.toggleLoading('programs'));
  const response: IApiExecuteRespone<IProgram[]> = yield call(api.fetchPrograms, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(programsActionCreators.setPrograms(response.value));
  }

  yield put(uiActionCreators.toggleLoading('programs'));
}

export function* watchFetchPrograms() {
  yield takeEvery(ProgramActionKeys.FETCH_PROGRAMS, fetchProgramsSaga);
}
